import type { Observable } from 'rxjs';

export abstract class VideoClipService {

  public abstract retranscode(videoId: string): Observable<void>;

}
